import React, { useState, useRef, useEffect } from "react";
import { sendMessage } from "../services/api";
import "./WelcomeScreen.css";

const WelcomeScreen = ({ onFirstMessage }) => {
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [cosmicText, setCosmicText] = useState("");
  const inputRef = useRef(null);
  const fullCosmicText = "Ask anything. Receive truth.";

  useEffect(() => {
    setCosmicText("");
    let index = 0;
    const interval = setInterval(() => {
      if (index <= fullCosmicText.length) {
        setCosmicText(fullCosmicText.slice(0, index));
        index++;
      } else {
        clearInterval(interval);
      }
    }, 60);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim() || isLoading) return;
    setIsLoading(true);
    try {
      const result = await sendMessage(input.trim());
      onFirstMessage(input.trim(), result.sessionId);
    } catch (err) {
      console.error("Failed:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="welcome-container">
      <div className="cosmic-rings">
        <div className="ring ring-1"></div>
        <div className="ring ring-2"></div>
        <div className="ring ring-3"></div>
      </div>
      <div className="welcome-center">
        <div className="zanox-sigil"><i className="fas fa-infinity"></i></div>
        <h1 className="welcome-title">ZANOX AI</h1>
        <p className="welcome-subtitle">{cosmicText}<span className="cursor-blink">|</span></p>
        <form onSubmit={handleSubmit} className="welcome-form">
          <div className="welcome-input-group">
            <input
              ref={inputRef}
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Enter your inquiry..."
              className="welcome-input"
              disabled={isLoading}
            />
            <button type="submit" className="welcome-submit" disabled={isLoading || !input.trim()}>
              {isLoading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-arrow-right"></i>}
            </button>
          </div>
        </form>
        <div className="welcome-capabilities">
          <div className="capability-item"><i className="fas fa-microphone"></i><span>Voice</span></div>
          <div className="capability-divider">|</div>
          <div className="capability-item"><i className="fas fa-image"></i><span>Vision</span></div>
          <div className="capability-divider">|</div>
          <div className="capability-item"><i className="fas fa-pen-fancy"></i><span>Handwriting</span></div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
